import { useEffect } from "react";
import { useGamepadContext } from "../contexts/GamepadProvider";

interface IMediaPreviewProps {
  setCurrentMediaIndex?: (index: number) => void;
}

export function useMediaPreview(props: IMediaPreviewProps) {
  const { setCurrentMediaIndex } = props;
  const { gamepadEmitter } = useGamepadContext();

  useEffect(() => {
    const handleGamepadEvent = (gamepadKey: string) => {
      if (gamepadKey === "left" || gamepadKey === "right") {
        const selectedElement = document.querySelector('[class*="selected"]');
        const activeMedia = selectedElement?.getAttribute("data-index");
        setCurrentMediaIndex?.(Number(activeMedia));
      }
    };
    gamepadEmitter.on("action", handleGamepadEvent);
    return () => {
      gamepadEmitter.off("action", handleGamepadEvent);
    };
  }, [gamepadEmitter, setCurrentMediaIndex]);
}
